import ActionResponse from './ActionResponse';

export default ActionResponse;
